import {
    GET_CYLINDER_LIST_PROGRESS, GET_CYLINDER_LIST_SUCCESS, GET_CYLINDER_LIST_FAILURE,
    ADD_CYLINDER_PROGRESS, ADD_CYLINDER_SUCCESS, ADD_CYLINDER_FAILURE,
    EDIT_DELETE_CYLINDER_PROGRESS, EDIT_DELETE_CYLINDER_SUCCESS, EDIT_DELETE_CYLINDER_FAILURE,

    RESET_MESSAGE,
    ADD_CYLINDER_CSV_PROGRESS,
    ADD_CYLINDER_CSV_SUCCESS,
    ADD_CYLINDER_CSV_FAILURE,

} from '../../types/actionTypes';

const initialState = {
    cylinder: [],
    loginUser: null,
    error: false,
    loading: false,
    message: null
}

const cylinder_reducer = (state = initialState, action) => {
    switch (action.type) {

        case GET_CYLINDER_LIST_SUCCESS:
            return { ...state, cylinder: action.cylinder, loading: false };
        case GET_CYLINDER_LIST_FAILURE:
            return { ...state, loading: false, error: true };
        case GET_CYLINDER_LIST_PROGRESS:
            return { ...state, loading: true, error: false };

        case ADD_CYLINDER_PROGRESS:
            return { ...state, loading: true };
        case ADD_CYLINDER_SUCCESS:
            return { ...state, cylinder: [...state.cylinder, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CYLINDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case ADD_CYLINDER_CSV_PROGRESS:
            return { ...state, loading: true };
        case ADD_CYLINDER_CSV_SUCCESS:
            return { ...state, cylinder: [...state.cylinder, action.payload], loading: false, error: false, message: action.payload.message };
        case ADD_CYLINDER_CSV_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case EDIT_DELETE_CYLINDER_PROGRESS:
            return { ...state, loading: true };
        case EDIT_DELETE_CYLINDER_SUCCESS:
            return {
                ...state,
                cylinder: state.cylinder.map((cylinder) =>
                    cylinder.id === action.payload.id ? action.payload : cylinder
                ),
                message: action.payload.message
            };
        case EDIT_DELETE_CYLINDER_FAILURE:
            return { ...state, loading: false, error: action.payload, message: action.payload.message };

        case RESET_MESSAGE:
            return { ...state, message: null };

        default:
            return state
    }
}

export default cylinder_reducer;